module.exports = __webpack_public_path__ + "static/media/14b-05-insolada.863d3e67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/14b/14b-05-insolada.jpg
// module id = 153
// module chunks = 0